import React from 'react';
import { CashInflowSegment } from '../accountingTypes';
import styles from './CashInflowBar.module.css';

interface Props {
  segments: CashInflowSegment[];
}

export const CashInflowBar: React.FC<Props> = ({ segments }) => {
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>Expected Cash Inflow</h3>

      <div className={styles.bar}>
        {segments.map((seg) => (
          <div
            key={seg.label}
            className={styles.segment}
            style={{ width: `${seg.percent}%`, background: seg.color }}
            title={`${seg.sublabel}: ${seg.amount}`}
          >
            <span className={styles.segLabel}>{seg.label}</span>
            <span className={styles.segAmount}>{seg.amount}</span>
          </div>
        ))}
      </div>

      <div className={styles.legend}>
        {segments.map((seg) => (
          <div key={seg.label} className={styles.legendItem}>
            <span className={styles.legendDot} style={{ background: seg.legendColor }} />
            <span className={styles.legendLabel}>{seg.sublabel}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
